"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationListStyled = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _const = require("../../const");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NotificationListChild = function NotificationListChild(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
};

var NotificationListStyled = (0, _utils.styled)(NotificationListChild)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  position: fixed;\n  z-index: 3000;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  ", " {\n    width: auto;\n    margin: 0;\n    left: 20px;\n    right: 20px;\n    transform: translate(0);\n  }\n  & > div > div:not(:last-of-type) {\n    margin: 0 0 30px;\n  }\n"])), function (_ref) {
  var measure = _ref.measure;
  return measure === 'md' && '400px' || measure === 'lg' && '600px' || measure === 'auto' && 'auto';
}, _const.GridBreakpointsMediaDown.sm);
exports.NotificationListStyled = NotificationListStyled;